import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExitService } from '../../services/exit.service';
import { TranslateService } from '../../services/translate.service';
import { Subscription } from 'rxjs';

interface SessionTimeoutEvent {
  secondsLeft: number;
  expired: boolean;
}

@Component({
  selector: 'app-session-timeout-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  showDialog = false;
  secondsLeft = 60;
  expired = false;
  private sub?: Subscription;

  constructor(private exitService: ExitService, public translateServ : TranslateService) {}

  ngOnInit() {
    this.sub = this.exitService.sessionTimeoutWarning$.subscribe((event: SessionTimeoutEvent) => {
      console.log('[Dialog] Received event:', event);
      this.handleSessionEvent(event);
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  private handleSessionEvent({ secondsLeft, expired }: SessionTimeoutEvent) {
    this.secondsLeft = secondsLeft;
    this.expired = expired;

    // Show the dialog while the countdown is active
    this.showDialog = !expired && secondsLeft > 0;

    // Only trigger cleanup when the service explicitly marks the session expired
    if (expired === true) {
      this.showDialog = false;
      this.exitService.expireSessionAndCleanup();
    }
  }

  onContinue() {
    console.log('[Dialog] Continue clicked');
    this.showDialog = false;
    this.exitService.continueSession();
  }

  onRejoin() {
    console.log('[Dialog] Rejoin clicked');
    this.showDialog = false;
    this.exitService.expireSessionAndCleanup();
  }
}
